import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function SmartReplyBar({ conversationId, lastMessageId, onPick }) {
  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!conversationId || !lastMessageId) {
      setReplies([]);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.post("/ai/smart-replies", { conversation_id: conversationId });
        if (!cancelled) setReplies(data?.replies || []);
      } catch {
        if (!cancelled) setReplies([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [conversationId, lastMessageId]);

  if (!replies.length && !loading) return null;

  return (
    <div className="px-3 pt-2 pb-1 flex items-center gap-2 flex-wrap" data-testid="smart-reply-bar">
      <div className="flex items-center gap-1 text-[10px] uppercase font-black tracking-widest text-[#555]">
        <Sparkles strokeWidth={3} className="w-3 h-3" /> Öneri
      </div>
      {loading && <span className="text-xs text-[#555]">…</span>}
      {replies.map((r, i) => (
        <button
          key={i}
          data-testid={`smart-reply-${i}`}
          onClick={() => onPick(r)}
          className="bg-white border-hard-2 rounded-full px-3 py-1 text-sm font-bold press-btn shadow-hard-sm"
        >
          {r}
        </button>
      ))}
    </div>
  );
}
